<template>
  <el-dialog
    class="set-month-task-modal"
    width="90%"
    :title="`${context[0] && context[0].month}销售任务设置`"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="config-table">
      <table>
        <tr>
          <td>区域</td>
          <td>活跃客户</td>
          <td>下单客户</td>
          <td>订单笔数</td>
          <td>急件销售额(万)</td>
          <td>批单销售额(万)</td>
          <td>机油销售额(万)</td>
        </tr>
        <tr v-for="areaData in context" :key="areaData.area">
          <td>{{ areaData.area }}</td>
          <td>
            <el-input-number
              size="mini"
              v-model="areaData.epcActive"
              :min="0"
              :step="1"
              :step-strictly="true"
              :precision="0"
              :controls="false"
              :placeholder="`请输入${areaData.area}目标活跃客户数`"
            />
          </td>
          <td>
            <el-input-number
              size="mini"
              v-model="areaData.buyerCount"
              :min="0"
              :step="1"
              :step-strictly="true"
              :controls="false"
              :precision="0"
              :placeholder="`请输入${areaData.area}目标下单客户数`"
            />
          </td>
          <td>
            <el-input-number
              size="mini"
              v-model="areaData.orderCount"
              :step="1"
              :min="0"
              :precision="0"
              :step-strictly="true"
              :controls="false"
              :placeholder="`请输入${areaData.area}目标订单笔数`"
            />
          </td>
          <td>
            <el-input-number
              size="mini"
              v-model="areaData.fastAmount"
              :step="1"
              :precision="0"
              :step-strictly="true"
              :controls="false"
              :placeholder="`请输入${areaData.area}目标急件销售额`"
            />
          </td>
          <td>
            <el-input-number
              size="mini"
              v-model="areaData.batchAmount"
              :step="1"
              :precision="0"
              :step-strictly="true"
              :controls="false"
              :placeholder="`请输入${areaData.area}目标批单销售额`"
            />
          </td>
          <td>
            <el-input-number
              size="mini"
              v-model="areaData.oilAmount"
              :step="1"
              :precision="0"
              :step-strictly="true"
              :controls="false"
              :placeholder="`请输入${areaData.area}目标机油销售额`"
            />
          </td>
        </tr>
      </table>
    </div>
    <div class="actions">
      <el-button size="small" @click="close(false)">取消</el-button>
      <el-button type="primary" size="small" @click="doSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import _ from 'lodash'
import { updateMonthTask } from '../services'
export default {
  name: 'SetMonthTaskModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      context: []
    }
  },
  methods: {
    init (context) {
      const editCtx = _.cloneDeep(context)
      editCtx.forEach(e => {
        e.fastAmount = e.fastAmount / 10000
        e.batchAmount = e.batchAmount / 10000
        e.oilAmount = e.oilAmount / 10000
      })
      this.context = editCtx
      return this.open()
    },
    checkModel () {
      return new Promise((resolve, reject) => {
        const nonEpcActive = this.context.find(t => !t.epcActive)
        if (nonEpcActive) {
          reject(new Error(`请输入${nonEpcActive.area}目标活跃客户数`))
          return
        }
        const nonBuyerCount = this.context.find(t => !t.buyerCount)
        if (nonBuyerCount) {
          reject(new Error(`请输入${nonBuyerCount.area}目标下单客户数`))
          return
        }
        const nonOrderCount = this.context.find(t => !t.orderCount)
        if (nonOrderCount) {
          reject(new Error(`请输入${nonOrderCount.area}目标订单比数`))
          return
        }
        const nonFastAmount = this.context.find(t => !t.fastAmount)
        if (nonFastAmount) {
          reject(new Error(`请输入${nonFastAmount.area}目标急件销售额`))
          return
        }
        const nonBatchAmount = this.context.find(t => !t.batchAmount)
        if (nonBatchAmount) {
          reject(new Error(`请输入${nonBatchAmount.area}目标批单销售额`))
          return
        }
        const nonOilAmount = this.context.find(t => !t.oilAmount)
        if (nonOilAmount) {
          reject(new Error(`请输入${nonOilAmount.area}目标机油销售额`))
          return
        }
        resolve(true)
      })
    },
    doSubmit () {
      this.checkModel().then(() => {
        const toPost = _.cloneDeep(this.context)
        toPost.forEach(e => {
          e.fastAmount = e.fastAmount * 10000
          e.batchAmount = e.batchAmount * 10000
          e.oilAmount = e.oilAmount * 10000
        })
        updateMonthTask(toPost).then(() => {
          this.close(true)
        })
      }).catch((err) => {
        this.$message.error(err.message)
      })
    }
  }
}
</script>
<style lang="stylus">
.set-month-task-modal
  .el-dialog
    max-width 960px
    .el-dialog__body
      padding-top 6px
      padding-bottom 20px
    .actions
      margin-top 12px
      text-align right
      .el-button
        width 100px
    .title
      font-size 16px
      font-weight bold
    table
      border-collapse collapse
      width 100%
      td
        padding 4px
        text-align center
        border 1px solid #e5e5e5
      tr
        td
          &:nth-child(1)
            background #f2f2f2
            width 80px
        &:hover
          &:not(:nth-child(1))
            background rgba(22,90,229,.2)
            td
              border-top-color #409eff
              border-top-style: double
              border-bottom-color #409eff
        &:nth-child(1)
          td
            background #f2f2f2
        &:not(:nth-child(1))
          td
            &:not(:nth-child(1))
              cursor pointer
</style>
